import { render, staticRenderFns } from "./SettingPlanDetail.vue?vue&type=template&id=2a1608ff&scoped=true&"
import script from "./SettingPlanDetail.vue?vue&type=script&lang=js&"
export * from "./SettingPlanDetail.vue?vue&type=script&lang=js&"
import style0 from "./SettingPlanDetail.vue?vue&type=style&index=0&id=2a1608ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1608ff",
  null
  
)

export default component.exports